export const AppRoutes = {
    callback: '/callback',
    loggedOut: '/logged-out',
    home: '/home',
    termsOfUse: '/terms-of-use',
    privacyPolicy: '/privacy-policy',
    updatesHistory: '/updates-history',
    intakeForm: '/intake-form',
    intakeSources: '/intake-sources',
    activeIntakeSources: '/intake-sources/active',
    archivedIntakeSources: '/intake-sources/archive',
    intakeCases: '/intake-cases',
    activeIntakeCases: '/intake-cases/active',
    monitoringIntakeCases: '/intake-cases/monitoring',
    archivedIntakeCases: '/intake-cases/archived',
    intakeCaseDetails: (intakeCaseId = ':intakeCaseId') => `/intake-cases/${intakeCaseId}`,
} as const;
